module.exports = __webpack_public_path__ + "img/transferQrcode.f51e3e6.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/transferQrcode.jpg
// module id = 8KQY
// module chunks = 2